export const colors: any = {
  primary: '#0491A4',
  secondary: '#F27043',
  bg1: '#F9F9F9',
  bg2: '#FFE3DD',
  bg3: '#FFC838',
  bg4: '#FFBEFF',
  light: '#FFFFFF',
  dark: '#000000',
  dark2: '#0A0A0A',
  text: '#262626',
  paragraph: '#444444',
  disabled: '#CBCBCB',
  line: '#D9D9D9',
  line2: '#e2e2e2',
  border: '#707070',
  background: '#F5F5F5',
  danger: '#FF0000',
  status: '#FF4200',
  mellow: '#FFF1CD',
  green: '#ECF8F2',
  light_green: '#95D6B6',
  dark_green: '#85bda1',
  out_stock: '#FF4646',
  shadow: '#00000024'
}

export const darkcolor: any = {
  mode: 'light',

  typo: {
    ...colors,
    gray: '#EEEEEE',
    pink: '#f8b8a083',
    dark_mellow: '#DCAD30'
  },

  statusBar: {
    ...colors,
  },

  breadcrumb: {
    ...colors,
  },

  header: {
    ...colors,
    hpBgColor: '#EBEBEB',
  },

  refresh: {
    ...colors,
  },

  container: {
    ...colors,
    light_yellow: '#ffc83880',
    light_pink: '#ffe3ddcc',
    pink: '#ffe3ddcc',
    green: '#ECF8F2',
    light_green: '#95D6B6',
    dark_green: '#A1E6C4'
  },

  footer: {
    ...colors,
  },

  drawer: {
    ...colors,
  },

  button: {
    ...colors,
  },

  form: {
    ...colors,
    borderColor: '#D9D9D9',
    light_gray: '#e2e2e2',
    light_gray2: '#EDEDED'
  },

  card: {
    ...colors,
    yellow: ' #FEB800',
    pink: '#F8B7A0',

  },

  list: {
    ...colors,
  },

  modal: {
    ...colors,
    light_green: '#E1F2E5'
  },

  loading: {
    ...colors,
  },

  icon: {
    ...colors,
  },

  table: {
    ...colors,
  },
}

export const lightcolor: any = {
  mode: 'light',

  typo: {
    ...colors,
    gray: '#EEEEEE',
    pink: '#f8b8a083',
    dark_mellow: '#DCAD30'
  },

  statusBar: {
    ...colors,
  },

  breadcrumb: {
    ...colors,
  },

  header: {
    ...colors,
    hpBgColor: '#EBEBEB',
  },

  refresh: {
    ...colors,
  },

  container: {
    ...colors,
    light_yellow: '#ffc83880',
    light_pink: '#ffe3ddcc',
    pink: '#ffe3ddcc',
    green: '#ECF8F2',
    light_green: '#95D6B6',
    dark_green: '#A1E6C4'
  },

  footer: {
    ...colors,
  },

  drawer: {
    ...colors,
  },

  button: {
    ...colors,
  },

  form: {
    ...colors,
    borderColor: '#D9D9D9',
    light_gray: '#e2e2e2',
    light_gray2: '#EDEDED'
  },

  card: {
    ...colors,
    yellow: '#FEB800',
    pink: '#F8B7A0',
    dark_pink: '#CC9784'
  },

  list: {
    ...colors,
  },

  modal: {
    ...colors,
    light_green: '#E1F2E5'
  },

  loading: {
    ...colors,
  },

  icon: {
    ...colors,
  },

  table: {
    ...colors,
  },
}
